export default class Accordions {
  constructor(accordion) {
    this.$ = accordion;
    this.wrapper = this.$;
    this.content = this.wrapper.querySelector('.js-acc-cont');
    this.condition = this.wrapper.getAttribute('data-expanded');
    this.buttons = Array.from(this.wrapper.querySelectorAll('.js-acc-btn'));
    this.duration = 200;
    this.openClass = 'm-opened';
    if (this.wrapper.querySelector('.js-acc-cover')) {
      this.cover = this.wrapper.querySelector('.js-acc-cover');
      this.btnSetting = this.wrapper.dataset.remove;
      this.duration = this.wrapper.dataset.duration;
    }
    if (this.$.classList.contains('js-acc-defaultHeight')) {
      // this.contentHeight = this.content.scrollHeight + 'px';
      this.defHeight = this.wrapper.dataset.height;
    }

    console.log(this.defHeight)
    this.initialize();
    this.bind();
  }

  initialize() {
    if (this.condition == 'true') {//open
      this.open();
    } else {//close
      this.close();
    }
  }

  bind() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.toggle.bind(this));
    })
  }

  toggle() {
    if (this.wrapper.getAttribute('data-expanded') == 'false') {//open
      this.open();
      let scID = this.$.dataset.accordion_serial;
      _sc.gene_click(scID, '');
    } else {//close
      this.close();
    }
  }

  open() {
    if (!this.$.classList.contains('js-acc-defaultHeight')){
      this.content.hidden = false;
      setTimeout(() => {
        this.content.style.opacity = 1;
      }, this.duration);
    }
    setTimeout(() => {
      this.wrapper.classList.add(this.openClass);
      this.wrapper.setAttribute('data-expanded', 'true');
    }, this.duration);
    if (this.btnSetting == 'true') {
      this.cover.style.display = 'none';
    }
    this.buttons.forEach((button) => {
      if (button.classList.contains('module-button__plus')) {
        button.classList.remove('module-button__plus');
        button.classList.add('module-button__minus');
      }
    });
  }

  close() {
    if (!this.$.classList.contains('js-acc-defaultHeight')) {
      this.content.style.opacity = 0;
      setTimeout(() => {
        this.content.hidden = true;
      }, this.duration);
    }
    this.wrapper.classList.remove(this.openClass);
    this.$.setAttribute('data-expanded', 'false');
    this.buttons.forEach((button) => {
      if (button.classList.contains('module-button__minus')) {
        button.classList.remove('module-button__minus');
        button.classList.add('module-button__plus');
      }
    });
  }

}

